import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";

import { Loading, Pagination } from "modules/primitives/index";
import styles from "./rightWindow.module.scss";
import CompanyBlockCompoant from "../companyBlock";
import { layoutType } from "../companyMain.constant";
import SimpleSearchComponent from "./simpleSearch/simpleSearch.component";
import CrunchBaseSearchComponent from "./crunchbaseSearch/crunchbaseSearch.component";
import SaveSearchComponent from "./saveSearch";
import {
  companySearchCrunchBase,
  searchCrunchBaseClear,
  searchInCouncil,
  setCompaniesTagsNotInCouncil,
  setScrolledTop,
  setSelectedCompanies,
} from "../companyMain.action";
import CrunchResults from "./crunchResults/crunchResults.component";
import { useModelPopup } from "../../../../common/hooks";
import { PAGINATION_DEFAULTS } from "../../constants";
import {
  queryParamStringToArray,
  queryStringUrlReplacement, useQuery,
} from "../../../../common/helper";
import { apiStatus, httpPost } from "../../../../common/httpCall";
import ChartsWrapper from "../chartsWrapper";
import NewCompaniesList from "./newCompaniesList";
import ChartTagsList from "../chartsWrapper/chartTagsList";
import { flat } from "../chartsWrapper/chartsView/charts/utils";
import style from "./newCompaniesList/newCompaniesList.module.scss";
import { appModelSettingSet } from "application/app.action";
import AddToIdeaComponent from "../addToIdea/addToIdea.component";
import AddCompanyComponent from "../addToProject";
import { followMultipleCompaniesAttempt } from "modules/projects/project/companies/companies.action";
import AddToListComponent from "../../../lists/components/addToList";
import { clearCreatedList } from "modules/lists/store/lists.actions";
import ChartsIntro from "../chartsWrapper/chartsIntro";
import {
  convertFilterIndexToValues,
  convertTagIdToIndex,
} from "common/helper.js";

const RightWindowComponent = ({ isFullWidth }) => {
  const {
    appReducer: { modalSetting, chartsDownloadIsActive },
    companiesReducer: {
      companyMainReducer: {
        companyList,
        loading,
        companiesPageNr,
        searchResults,
        searchResultNr,
        productsResultNr,
        crunchCompaniesSearched,
        checkedFilters,
        industries,
        topics,
        crunchLoading,
        relationshipOwners,
        isScrolled,
        companiesTagsNotInCouncil,
        selectedCompanies,
        charts: { chartsIntroIsActive },
      },
    },
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const toggleFilter = useQuery().get("toggle");

  const [selectLayout, setSelectLayout] = useState(location.state?.layout || 0);
  const [showCrunchBase, setShowCrunchBase] = useState(false);
  const [propValue, setPropValue] = useState(false);
  const [pageSetting, setPageSetting] = useState(PAGINATION_DEFAULTS);
  const [companies, setCompanies] = useState(null);
  const [itemToBeAppended, setItemToBeAppended] = useState(null);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedCustomTags, setSelectedCustomTags] = useState([]);

  const [locationType, setLocationType] = useState(null);
  const [selectModeIsActive, setSelectModeIsActive] = useState(false);
  const [downloadPdfIsActive, setDownloadPdfIsActive] = useState(false);

  const selectedCompaniesDetails = useMemo(() => {
    if (!selectedCompanies?.length) {
      return {
        total: 0,
        companies: 0,
        products: 0,
      };
    }

    const nrOfProducts = selectedCompanies.filter(
      (item) => item.is_product
    ).length;
    const nrOfCompanies = selectedCompanies.filter(
      (item) => !item.is_product
    ).length;

    return {
      total: selectedCompanies.length,
      companies: nrOfCompanies,
      products: nrOfProducts,
    };
  }, [selectedCompanies]);

  useEffect(() => {
    if (
      downloadPdfIsActive &&
      selectLayout === 1 &&
      selectedCompanies.length === 0
    ) {
      getCompaniesWithParams(500);
    }
  }, [downloadPdfIsActive]);

  const popup = useModelPopup();

  const showProductsCount = useMemo(() => {
    if (productsResultNr > 0 && productsResultNr && toggleFilter !== '1') {
      const { state } = location;

      if (!state) return true;

      const doesItMeetCondition = state.custom_tags_ids?.length ||
        state.location?.length ||
        state.scoreFrom?.length ||
        state.scoreTo?.length ||
        state.foundedFrom ||
        state.foundedTo ||
        state.employees?.length ||
        state.estimatedRevenue?.length ||
        state.fundingFrom?.length ||
        state.fundingTo?.length ||
        state.agreements?.length;

      if (selectedCouncil?.name === "Kyndryl") {
        return !doesItMeetCondition;
      }

      return !(doesItMeetCondition || state.lists?.length);
    }

    return false;
  }, [location, productsResultNr, toggleFilter, selectedCouncil, selectedCouncil])

  const genericResultsNr = useMemo(() => {
    if (showProductsCount) return Number(searchResultNr) + Number(productsResultNr || 0);
    return Number(searchResultNr);
  }, [productsResultNr, searchResultNr, showProductsCount]);

  const showPagination =
    !loading &&
    !showCrunchBase &&
    companies?.length > 0 &&
    (genericResultsNr > pageSetting.pageSize ||
      companiesPageNr?.total > pageSetting.pageSize);

  useEffect(
    () => () =>
      dispatch(
        setSelectedCompanies({
          shouldReset: true,
          companies: [],
        })
      ),
    []
  );

  useEffect(() => {
    if (selectedCompanies?.length) {
      setSelectModeIsActive(true);
    }

    return () => null;
  }, [selectedCompanies]);

  useEffect(() => {
    if (searchResults?.length && topics?.length && industries?.length) {
      const flattenTopics = flat(topics, "children_topics");
      const flattenIndustries = flat(industries, "children_industries");
      const tagsThatAreNotInCouncil = searchResults.reduce(
        (acc, company) => {
          const topicsThatDoesntExist = company.resource_topics
            ? company.resource_topics
                .filter(
                  (tag) =>
                    !flattenTopics.some((t) => t.id === tag.resource_topic_id)
                )
                .map((item) => item.topic)
            : [];
          const industriesThatDoesntExist = company.resource_industries
            ? company.resource_industries
                .filter(
                  (tag) =>
                    !flattenIndustries.some(
                      (t) => t.id === tag.resource_industry_id
                    )
                )
                .map((item) => item.industry)
            : [];
          const newTopics = [...acc.topics, ...topicsThatDoesntExist].filter(
            (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
          );
          const newIndustries = [
            ...acc.industries,
            ...industriesThatDoesntExist,
          ].filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);

          return {
            topics: newTopics,
            industries: newIndustries,
          };
        },
        {
          topics: [],
          industries: [],
        }
      );

      dispatch(setCompaniesTagsNotInCouncil(tagsThatAreNotInCouncil));
    }

    return () => null;
  }, [topics, industries, searchResults]);

  useEffect(() => {
    if (!location.state) {
      setSelectLayout(0);
      setSelectedTopics([]);
      setSelectedIndustries([]);
      setSelectedCustomTags([]);
      return;
    }

    if (location.state.topic && topics) {
      const asArr = queryParamStringToArray(location.state.topic);
      const flattenTopics = flat(topics, "children_topics");
      const filteredTopics = [
        ...companiesTagsNotInCouncil.topics,
        ...flattenTopics,
      ].filter((t) => asArr.includes(t.id));
      setSelectedTopics(filteredTopics);
    } else {
      setSelectedTopics([]);
    }

    if (location.state.industry && industries) {
      const asArr = queryParamStringToArray(location.state.industry);
      const flattenIndustries = flat(industries, "children_industries");
      const filteredIndustries = [
        ...companiesTagsNotInCouncil.industries,
        ...flattenIndustries,
      ].filter((t) => asArr.includes(t.id));
      setSelectedIndustries(filteredIndustries);
    } else {
      setSelectedIndustries([]);
    }
    if (location.state.custom_tags_ids) {
      const arrIndexes = queryParamStringToArray(
        location.state.custom_tags_ids
      );
      const arrTagsIds = convertFilterIndexToValues(
        arrIndexes,
        selectedCouncil?.council_custom_tag_groups
      );

      setSelectedCustomTags(
        arrTagsIds.map((id) => ({
          id,
        }))
      );
    } else {
      setSelectedCustomTags([]);
    }

    return () => null;
  }, [
    location,
    industries,
    topics,
    companiesTagsNotInCouncil,
    selectedCouncil,
  ]);
  const onScrollEventFunc = (event) => {
    const scrolled = event.target.scrollTop;
    if (scrolled > 0 && !isScrolled) {
      dispatch(setScrolledTop(true));
    } else if (scrolled === 0 && isScrolled) {
      dispatch(setScrolledTop(false));
    }
  };

  useEffect(() => {
    if (location?.state?.location) {
      const locationStrAsArray = queryParamStringToArray(
        location?.state?.location || ""
      );

      if (locationStrAsArray.length) {
        const splitedValue = locationStrAsArray
          .map((str) => str.replace(/-/g, ","))[0]
          .split(",")[0]
          .split("#");
        const type = splitedValue[1];

        if (type) {
          setLocationType(type);
        }
      }
    }
  }, [location]);

  useEffect(() => {
    if (!location.state || !selectedCouncil) {
      setShowCrunchBase(false);

      return;
    }

    if (
      location.state?.isCrunchSearch &&
      JSON.parse(location.state?.isCrunchSearch)
    ) {
      setShowCrunchBase(true);
    }

    if (
      location.state?.query &&
      location.state?.isCrunchSearch &&
      JSON.parse(location.state?.isCrunchSearch)
    ) {
      getCompaniesCrunchWithParams();
    }

    return () => null;
  }, [location, selectedCouncil]);

  useEffect(() => {
    if (
      location.state &&
      location.state.page &&
      location.state.page !== pageSetting.current
    ) {
      setPageSetting({
        ...pageSetting,
        current: Number(location.state.page),
      });
    }

    return () => null;
  }, [pageSetting, location]);

  useEffect(() => {
    if (!selectedCouncil) {
      return;
    }

    setPropValue(location?.state?.query);
    getCompaniesWithParams();

    return () => null;
  }, [selectedCouncil, location]);

  useEffect(() => {
    if (!searchResults?.length && !companyList?.length) {
      setCompanies([]);

      return;
    }

    if (searchResults?.length) {
      if (itemToBeAppended) {
        setCompanies([
          {
            ...itemToBeAppended,
            appendedItem: true,
          },
          ...searchResults.filter((i) => i.id !== itemToBeAppended.id),
        ]);

        return;
      }

      setCompanies(searchResults);

      return;
    }

    if (companyList?.length) {
      if (itemToBeAppended) {
        setCompanies([
          {
            ...itemToBeAppended,
            appendedItem: true,
          },
          ...companyList.filter((i) => i.id !== itemToBeAppended.id),
        ]);

        return;
      }

      setCompanies([...companyList]);

      return;
    }

    return () => null;
  }, [itemToBeAppended, searchResults, companyList]);

  useEffect(() => {
    if (!location.state) {
      return;
    }

    if (
      (!location.state.isCrunchSearch ||
        !JSON.parse(location.state.isCrunchSearch)) &&
      showCrunchBase
    ) {
      setShowCrunchBase(false);

      // we need to reset crunch search query params
      const search1 = queryStringUrlReplacement(
        history.location.search,
        "page",
        1
      );
      const search2 = queryStringUrlReplacement(search1, "afterId", "");
      const search = queryStringUrlReplacement(search2, "beforeId", "");

      history.push({
        pathname: "/companies",
        search,
        state: {
          ...history.location?.state,
          page: 1,
          afterId: "",
          beforeId: "",
        },
      });
    }

    return () => null;
  }, [location, showCrunchBase]);

  const getCompaniesCrunchWithParams = useCallback(() => {
    const { state } = location;

    if (state.afterId && location.state.afterId.length > 0) {
      dispatch(
        companySearchCrunchBase({
          data: state.query,
          council_id: selectedCouncil.id,
          limit: 50,
          after_id: state.afterId,
          enqueueSnackbar,
        })
      );

      return;
    }

    if (state.beforeId && state.beforeId.length > 0) {
      dispatch(
        companySearchCrunchBase({
          data: state.query,
          council_id: selectedCouncil.id,
          limit: 50,
          before_id: state.beforeId,
          enqueueSnackbar,
        })
      );

      return;
    }

    dispatch(
      companySearchCrunchBase({
        data: state.query,
        limit: 50,
        council_id: selectedCouncil.id,
        enqueueSnackbar,
      })
    );
  }, [location, selectedCouncil]);

  const getCompaniesWithParams = useCallback(() => {
    // don't make other calls when we are in the charts view
    // and we do some changes in the left filters
    if (location.state?.layout === 2 || !selectedCouncil) return;

    const { state, search } = location;

    const queryParams = new URLSearchParams(search);
    const page = queryParams.get("page")
      ? Number(queryParams.get("page"))
      : state?.page
      ? Number(state?.page)
      : 1;
    const query = queryParams.get("query") || state?.query || "";

    setPageSetting({
      ...pageSetting,
      current: page,
    });

    const businessUnits = queryParamStringToArray(state?.businessUnits || "");
    const relationShipStatus = queryParamStringToArray(
      state?.relationShipStatus || ""
    );
    const investmentStages = queryParamStringToArray(
      state?.investmentStages || ""
    );
    const topics = queryParamStringToArray(state?.topic || "");
    const industries = queryParamStringToArray(state?.industry || "");
    const owners = queryParamStringToArray(state?.owners || "");
    const locationStrAsArray = queryParamStringToArray(state?.location || "");
    const agreements = queryParamStringToArray(state?.agreements || "");
    const idb_connection_options = queryParamStringToArray(
      state?.idbEcosystem || ""
    );
    const location_countries = queryParamStringToArray(state?.k_country || "");
    const custom_tags_ids = queryParamStringToArray(
      state?.custom_tags_ids || ""
    );
    const locationProps = {};

    if (locationStrAsArray.length) {
      const splitedValue = locationStrAsArray
        .map((str) => str.replace(/-/g, ","))[0]
        .split(",")[0]
        .split("#");
      const value = splitedValue[0];
      const type = splitedValue[1];

      if (splitedValue) {
        locationProps[`location_${type}`] = value;
      }
    }

    const payload = {
      data: query,
      topic_ids: topics,
      industry_ids: industries,
      relationship_stages: relationShipStatus,
      council_company_score_gte: state?.scoreFrom
        ? Number(state?.scoreFrom)
        : null,
      council_company_score_lte: state?.scoreTo ? Number(state?.scoreTo) : null,
      founded_gte: state?.foundedFrom ? state?.foundedFrom : null,
      founded_lte: state?.foundedTo ? state?.foundedTo : null,
      relationship_owners_ids: owners,
      num_employee_enum: state?.employees ? state?.employees : "",
      revenue_range: state?.estimatedRevenue ? state?.estimatedRevenue : "",
      lists: state?.lists ? state?.lists : "",
      total_founding_gte: state?.fundingFrom
        ? Number(state?.fundingFrom.replace(/\D/g, ""))
        : null,
      total_founding_lte:
        state?.fundingTo && state?.fundingTo !== "Any Amount"
          ? Number(state?.fundingTo.replace(/\D/g, ""))
          : null,
      council_id: selectedCouncil.id,
      mode: "companies",
      page,
      items: state?.layout && state?.layout === 1 ? 50 : 20,
      withContext: true,
      sort_attribute: state?.sortAttribute || "",
      sort_order: state?.sortOrder || "",
      locationProps,
      agreements,
      enqueueSnackbar,
      location_countries,
      idb_connection_options,
      council_relationship_stage_id: relationShipStatus,
      business_unit_ids: businessUnits,
      theme_investment_stage_id: investmentStages,
      custom_tags_ids: convertFilterIndexToValues(
        custom_tags_ids,
        selectedCouncil?.council_custom_tag_groups
      ),
      cb: () => {},
      filter: state?.toggle,
    };
    dispatch(searchInCouncil(payload));
  }, [location, selectLayout, selectedCouncil, checkedFilters]);

  const handleRelationShipChange = useCallback(
    (shouldntRequest) => {
      if (shouldntRequest) return;

      const relationShipStatus = queryParamStringToArray(
        location?.state?.relationShipStatus || ""
      );

      if (!relationShipStatus?.length) return;

      getCompaniesWithParams();
    },
    [location, selectedCouncil]
  );

  const handleSaveHide = () => {
    popup.hide();
    dispatch(clearCreatedList());
  };

  const handleSaveSearch = useCallback(() => {
    popup.show({
      title: "Add Company List",
      component: (
        <SaveSearchComponent
          query={location.state?.query}
          checkedFilters={checkedFilters}
          handleSaveHide={handleSaveHide}
        />
      ),
    });
  }, [checkedFilters, location.state?.query]);

  const clickOnTag = (e, item, type, groupId) => {
    e.preventDefault();
    e.stopPropagation();

    let value;

    if (type === "topic") {
      const isAlreadySelected = selectedTopics.some((i) => i.id === item);

      if (isAlreadySelected) {
        const topicsArrAsString = selectedTopics
          .map((t) => t.id)
          .filter((i) => i !== item);
        value = topicsArrAsString.reduce(
          (acc, elem) => `${acc}${acc.length ? "," : ""}${elem}`,
          ""
        );
      } else {
        const topicsArrAsString = [...selectedTopics.map((t) => t.id), item];
        value = topicsArrAsString.reduce(
          (acc, elem) => `${acc}${acc.length ? "," : ""}${elem}`,
          ""
        );
      }
    }

    if (type === "industry") {
      const isAlreadySelected = selectedIndustries.some((i) => i.id === item);

      if (isAlreadySelected) {
        const industriesArrAsString = selectedIndustries
          .map((t) => t.id)
          .filter((i) => i !== item);
        value = industriesArrAsString.reduce(
          (acc, elem) => `${acc}${acc.length ? "," : ""}${elem}`,
          ""
        );
      } else {
        const industriesArrAsString = [
          ...selectedIndustries.map((t) => t.id),
          item,
        ];
        value = industriesArrAsString.reduce(
          (acc, elem) => `${acc}${acc.length ? "," : ""}${elem}`,
          ""
        );
      }
    }
    if (type === "custom_tags_ids") {
      const isAlreadySelected = selectedCustomTags.some((i) => i.id === item);
      if (isAlreadySelected) {
        const tagsArrAsString = selectedCustomTags
          .map((t) => t.id)
          .filter((i) => i !== item)
          .map((tagId) =>
            convertTagIdToIndex(
              tagId,
              selectedCouncil?.council_custom_tag_groups,
              groupId
            )
          );

        value = tagsArrAsString.reduce(
          (acc, elem) => `${acc}${acc.length ? "," : ""}${elem}`,
          ""
        );
      } else {
        value = convertTagIdToIndex(
          item,
          selectedCouncil?.council_custom_tag_groups,
          groupId
        );
      }
    }

    let search = queryStringUrlReplacement(
      history.location.search,
      type,
      value
    );
    search = queryStringUrlReplacement(search, "page", 1);

    history.push({
      pathname: "/companies",
      search,
      state: {
        ...history.location?.state,
        [type]: value,
        page: 1,
      },
    });
  };

  useEffect(() => {
    if (searchResults || companiesPageNr) {
      const pageSize =
        selectLayout === 1
          ? genericResultsNr > pageSetting.pageSize ||
            companiesPageNr?.total > pageSetting.pageSize
            ? 50
            : 20
          : 20;

      setPageSetting({
        ...pageSetting,
        total: !showProductsCount ? searchResultNr : genericResultsNr,
        pageSize,
      });
    }

    return () => null;
  }, [searchResults, companiesPageNr, selectLayout, genericResultsNr, showProductsCount]);

  const handleLayoutClick = useCallback(
    (layout) => {
      setSelectLayout(layout);

      const search = queryStringUrlReplacement(
        history.location.search,
        "layout",
        layout
      );

      history.push({
        pathname: "/companies",
        search,
        state: {
          ...history.location.state,
          layout,
        },
      });
    },
    [selectLayout]
  );

  const handleCrunchBase = useCallback(
    (val, resetQuery) => {
      let search = queryStringUrlReplacement(
        history.location.search,
        "isCrunchSearch",
        val
      );
      search = queryStringUrlReplacement(search, "page", 1);

      if (companies?.length) {
        search = queryStringUrlReplacement(search, "topic", []);
        search = queryStringUrlReplacement(search, "industry", []);
      }

      const tagsToReset = companies?.length
        ? { topic: null, industry: null }
        : {};

      if (resetQuery) {
        search = queryStringUrlReplacement(search, "query", "");
      }

      let stringifyValue;

      if (companies?.length === 0 && val && !resetQuery) {
        const combined = [...selectedTopics, ...selectedIndustries];

        if (!history.location?.state?.query && combined.length > 0) {
          stringifyValue = combined.reduce(
            (acc, elem) => `${acc}${!acc.length ? "" : ","} ${elem.name}`,
            ""
          );

          search = queryStringUrlReplacement(search, "query", stringifyValue);
        }
      }

      const query = resetQuery
        ? ""
        : stringifyValue || history.location?.state?.query || "";

      history.push({
        pathname: "/companies",
        search,
        state: {
          ...history.location?.state,
          isCrunchSearch: val,
          page: 1,
          query,
          ...tagsToReset,
        },
      });

      setShowCrunchBase(val);
    },
    [selectLayout, layoutType, selectedTopics, selectedIndustries, companies]
  );

  const addToTraction = useCallback(
    (company) => {
      httpPost({
        apiVersion: "v2",
        call: "council_companies",
        data: {
          company_name: company.name,
          crunchbase_slug: company.permalink,
          company_website: company.website,
        },
      }).subscribe((result) => {
        if (
          result.status === apiStatus.SUCCESS ||
          result.status === apiStatus.CREATED
        ) {
          if (selectedCouncil?.name === "Kyndryl") {
            history.push({
              pathname: `/companies/${
                result.response.slug || result.response.id
              }`,
              search: "?showAddRelationShip=true",
              state: {
                ...history.location?.state,
                showAddRelationShip: true,
              },
            });

            return;
          }

          setItemToBeAppended(result.response);

          enqueueSnackbar("Successfully added company.", {
            variant: "success",
          });

          handleCrunchBase(false, true);

          dispatch(searchCrunchBaseClear({}));
          history.push({
            pathname: "/companies",
          });
        } else {
          enqueueSnackbar("Something wrong happened", {
            variant: "error",
          });
        }
      });
    },
    [selectedCouncil, selectLayout]
  );

  const handlePagingChange = useCallback(
    (selectedPage) => {
      if (
        selectedPage === Number(location.state?.page || 1) ||
        showCrunchBase ||
        pageSetting.current === selectedPage
      ) {
        return;
      }

      const search = queryStringUrlReplacement(
        history.location.search,
        "page",
        selectedPage
      );

      history.push({
        pathname: "/companies",
        search,
        state: {
          ...history.location?.state,
          page: selectedPage,
        },
      });
    },
    [location, showCrunchBase, pageSetting, selectLayout, layoutType]
  );

  const selectAll = () => {
    if (selectedCompanies.length) {
      dispatch(
        setSelectedCompanies({
          shouldReset: true,
          companies: [],
        })
      );
    } else {
      dispatch(
        setSelectedCompanies({
          companies,
        })
      );
    }
  };

  const handleMoreOptionClick = (value) => {
    switch (value) {
      case 1:
        {
          let clearedCompanies = selectedCompanies;

          if (selectedCompaniesDetails?.products > 0) {
            clearedCompanies = selectedCompanies.filter((c) => !c.is_product);
          }

          const payload = {
            follow_relationships: clearedCompanies.map((c) => ({
              following_id: c.id,
            })),
            enqueueSnackbar,
            cb: () => {
              const newCompanies = companies.map((c) => {
                const getFollowingCompany = payload.follow_relationships.find(
                  (f) => f.following_id === c.id
                );

                if (getFollowingCompany) {
                  return {
                    ...c,
                    following: true,
                  };
                }

                return c;
              });

              setCompanies(newCompanies);
            },
          };

          dispatch(followMultipleCompaniesAttempt(payload));
        }
        break;

      case 2:
        {
          const payload = {
            title: "Add To List",
            show: true,
            height: "1000",
            width: "540",
            component: (
              <AddToListComponent
                enqueueSnackbar={enqueueSnackbar}
                getMyOnlyLists
                companyIds={selectedCompanies.map((c) => c.id)}
                multipleAdd
              />
            ),
          };

          dispatch(
            appModelSettingSet({
              ...modalSetting,
              ...payload,
            })
          );
        }
        break;

      case 6:
        {
          const payload = {
            title: "Add To Idea",
            show: true,
            height: "1000",
            width: "540",
            component: (
              <AddToIdeaComponent
                selectedCompanies={selectedCompanies}
                company={null}
                selectedCouncil={selectedCouncil}
                enqueueSnackbar={enqueueSnackbar}
              />
            ),
          };

          dispatch(
            appModelSettingSet({
              ...modalSetting,
              ...payload,
            })
          );
        }
        break;

      case 3: {
        let filteredCompanies = selectedCompanies;

        if (selectedCompaniesDetails?.products > 0) {
          filteredCompanies = selectedCompanies.filter((c) => !c.is_product);
        }

        const payload = {
          title: "Add Companies To Project",
          show: true,
          height: "1000",
          width: "540",
          component: (
            <AddCompanyComponent
              companyIds={filteredCompanies.map((c) => c.id)}
              enqueueSnackbar={enqueueSnackbar}
              multipleAdd
            />
          ),
        };

        dispatch(
          appModelSettingSet({
            ...modalSetting,
            ...payload,
          })
        );
      }
    }
  };

  const handleCompanySelect = (company) => {
    const companyIsSelected = selectedCompanies.some(
      (c) => c.id === company.id
    );

    if (companyIsSelected) {
      const selected = selectedCompanies.filter((c) => c.id !== company.id);
      dispatch(
        setSelectedCompanies({
          companies: selected,
        })
      );
    } else {
      dispatch(
        setSelectedCompanies({
          companies: [...selectedCompanies, company],
        })
      );
    }
  };

  const handleSelectMode = () => {
    setSelectModeIsActive(!selectModeIsActive);

    if (!selectModeIsActive) {
      dispatch(
        setSelectedCompanies({
          companies: [],
        })
      );
    }
  };

  return (
    <div className="w-100">
      <div
        className={`${styles.wrapper} ${
          chartsDownloadIsActive
            ? styles.fullHeightWrapper
            : styles.lessHeightWrapper
        } ${isFullWidth ? styles.fullWidthWrapper : styles.partialWrapper}`}
        onScroll={onScrollEventFunc}
        id="rightWindow"
      >
        <div
          className={`${styles.searchWrapper} ${
            selectLayout === 2 ? "pt-5" : "pt-0"
          }`}
        >
          {showCrunchBase ? (
            <CrunchBaseSearchComponent
              handleCrunchBase={handleCrunchBase}
              selectLayout={selectLayout}
              isFullWidth={isFullWidth}
              selectedTopics={selectedTopics}
              selectedIndustries={selectedIndustries}
            />
          ) : (
            <>
              <SimpleSearchComponent
                handleLayout={handleLayoutClick}
                layout={selectLayout}
                handleSaveSearch={handleSaveSearch}
                handleCrunchBase={handleCrunchBase}
                mode="companies"
                patientOrg={false}
                query={propValue}
                checkedFilters={checkedFilters}
                location={location}
                selectModeIsActive={selectModeIsActive}
                setDownloadPdfIsActive={setDownloadPdfIsActive}
                selectedCompanies={selectedCompanies}
              />
            </>
          )}
        </div>
        {crunchLoading || loading ? (
          <div className={styles.container}>
            <Loading />
          </div>
        ) : (
          <>
            {selectLayout !== 2 && (
              <div id="downloadableSection" className={styles.container}>
                {showCrunchBase ? (
                  <CrunchResults
                    addToTraction={addToTraction}
                    crunchCompaniesSearched={crunchCompaniesSearched}
                    query={location.state?.query}
                    selectLayout={selectLayout}
                    page={location.state?.page}
                    isFullWidth={isFullWidth}
                  />
                ) : (
                  <>
                    {(!location.state?.query ||
                      location.state?.query?.length === 0) &&
                    pageSetting?.current === 1 &&
                    genericResultsNr ? (
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex flex-column flex-grow-1">
                          <ChartTagsList usedOutsideCharts />
                          {downloadPdfIsActive ? (
                            <div className="d-flex flex-row align-items-center mt-2 flex-grow-1">
                              <div className={styles.logoWrp}>
                                <img
                                  width="100"
                                  height="100"
                                  alt={selectedCouncil.name}
                                  src={selectedCouncil.logo}
                                />
                              </div>
                              <h2 className="mb-0 bold mt-2 d-flex justify-content-center w-100">
                                Traction Report
                              </h2>
                            </div>
                          ) : null}
                          {selectLayout !== 2 && !downloadPdfIsActive && (
                            <div className="d-flex align-items-center mt-2">
                              <span
                                className={style.selectMode}
                                onClick={handleSelectMode}
                              >
                                {selectModeIsActive ? "Hide" : "Select"}
                              </span>
                              {selectModeIsActive && (
                                <span
                                  onClick={selectAll}
                                  className={`${style.selectMode} ml-3`}
                                >
                                  {selectedCompanies.length
                                    ? "Deselect All"
                                    : "Select All"}
                                </span>
                              )}
                              {selectModeIsActive &&
                              selectedCompanies.length ? (
                                <div className="d-flex align-items-center ml-5">
                                  <span
                                    className={`${style.selectMode} font-weight-bold`}
                                    onClick={() => handleMoreOptionClick(2)}
                                  >
                                    Add to List
                                  </span>
                                  {selectedCompaniesDetails?.companies > 0 ? (
                                    <span
                                      className={`${style.selectMode} font-weight-bold ml-3`}
                                      onClick={() => handleMoreOptionClick(3)}
                                    >
                                      Add to Project
                                    </span>
                                  ) : null}
                                  {selectedCouncil.name !== "GSK" &&
                                    selectedCouncil?.settings
                                      ?.ideas_connected && (
                                      <span
                                        className={`${style.selectMode} font-weight-bold ml-3`}
                                        onClick={() => handleMoreOptionClick(6)}
                                      >
                                        Add to Idea
                                      </span>
                                    )}

                                  {selectedCompaniesDetails?.companies > 0 ? (
                                    <span
                                      className={`${style.selectMode} font-weight-bold ml-3`}
                                      onClick={() => handleMoreOptionClick(1)}
                                    >
                                      Follow All
                                    </span>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          {downloadPdfIsActive ? (
                            <div className={styles.resultCon}>
                              {selectModeIsActive && selectedCompanies.length
                                ? `${selectedCompanies.length} Selected`
                                : `1-${companies.length} of ${genericResultsNr} Results`}
                            </div>
                          ) : (
                            <div className={styles.resultCon}>
                              {selectModeIsActive && selectedCompanies.length
                                ? `${selectedCompanies.length} Selected`
                                : (
                                  <div className="d-flex flex-column">
                                    {
                                      toggleFilter !== '2' && (
                                        <span>{`${searchResultNr} Compan${searchResultNr > 1 ? 'ies' : 'y'}`}</span>
                                      )
                                    }
                                    {
                                      showProductsCount && (
                                        <span>{`${productsResultNr} Product${productsResultNr > 1 ? 's' : ''}`}</span>
                                      )
                                    }
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                    {(location.state?.query ||
                      location.state?.query?.length > 0 ||
                      pageSetting?.current !== 1) &&
                    companies?.length &&
                    genericResultsNr ? (
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex flex-column flex-grow-1">
                          <ChartTagsList usedOutsideCharts />
                          {downloadPdfIsActive ? (
                            <div className="d-flex flex-row align-items-center mt-2 flex-grow-1">
                              <div className={styles.logoWrp}>
                                <img
                                  alt={selectedCouncil.name}
                                  src={selectedCouncil.logo}
                                />
                              </div>
                              <h2 className="mb-0 bold mt-2 d-flex justify-content-center w-100">
                                Traction Report
                              </h2>
                            </div>
                          ) : null}
                          {selectLayout !== 2 && !downloadPdfIsActive && (
                            <div className="d-flex align-items-center mt-2">
                              <span
                                className={style.selectMode}
                                onClick={() =>
                                  setSelectModeIsActive(!selectModeIsActive)
                                }
                              >
                                Select
                              </span>
                              {selectModeIsActive && (
                                <span
                                  onClick={selectAll}
                                  className={`${style.selectMode} ml-3`}
                                >
                                  {selectedCompanies.length
                                    ? "Deselect All"
                                    : "Select All"}
                                </span>
                              )}
                              {selectModeIsActive &&
                              selectedCompanies.length ? (
                                <div className="d-flex align-items-center ml-5">
                                  <span
                                    className={`${style.selectMode} font-weight-bold`}
                                    onClick={() => handleMoreOptionClick(2)}
                                  >
                                    Add to List
                                  </span>
                                  {selectedCompaniesDetails?.companies > 0 ? (
                                    <span
                                      className={`${style.selectMode} font-weight-bold ml-3`}
                                      onClick={() => handleMoreOptionClick(3)}
                                    >
                                      Add to Project
                                    </span>
                                  ) : null}
                                  {selectedCouncil.name !== "GSK" && (
                                    <span
                                      className={`${style.selectMode} font-weight-bold ml-3`}
                                      onClick={() => handleMoreOptionClick(6)}
                                    >
                                      Add to Idea
                                    </span>
                                  )}
                                  {selectedCompaniesDetails?.companies > 0 ? (
                                    <span
                                      className={`${style.selectMode} font-weight-bold ml-3`}
                                      onClick={() => handleMoreOptionClick(1)}
                                    >
                                      Follow All
                                    </span>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          <div className={styles.resultCon}>
                            {selectModeIsActive && selectedCompanies.length
                              ? `${selectedCompanies.length} Selected`
                              : pageSetting.pageSize > genericResultsNr
                              ? `${genericResultsNr} of ${genericResultsNr} Results`
                              : `${
                                  pageSetting.pageSize * pageSetting.current -
                                  (selectLayout === 0 ? 19 : 49)
                                } - ${
                                  pageSetting.pageSize * pageSetting.current
                                } of ${genericResultsNr} Results`}
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {selectLayout === 0 ? (
                      companies?.length > 0 ? (
                        <>
                          {downloadPdfIsActive && selectedCompanies?.length ? (
                            <>
                              {selectedCompanies.map((company) => (
                                <CompanyBlockCompoant
                                  key={company.id}
                                  company={company}
                                  enqueueSnackbar={enqueueSnackbar}
                                  clickOnTag={clickOnTag}
                                  checkedTags={[
                                    ...selectedTopics,
                                    ...selectedIndustries,
                                    ...selectedCustomTags,
                                  ]}
                                  relationshipOwners={relationshipOwners}
                                  locationType={locationType}
                                  handleRelationShipChange={
                                    handleRelationShipChange
                                  }
                                  handleCompanySelect={() =>
                                    handleCompanySelect(company)
                                  }
                                />
                              ))}
                            </>
                          ) : (
                            <>
                              {companies.map((company) => (
                                <CompanyBlockCompoant
                                  key={company.id}
                                  company={company}
                                  enqueueSnackbar={enqueueSnackbar}
                                  clickOnTag={clickOnTag}
                                  checkedTags={[
                                    ...selectedTopics,
                                    ...selectedIndustries,
                                    ...selectedCustomTags,
                                  ]}
                                  relationshipOwners={relationshipOwners}
                                  locationType={locationType}
                                  handleRelationShipChange={
                                    handleRelationShipChange
                                  }
                                  selectModeIsActive={selectModeIsActive}
                                  handleCompanySelect={() =>
                                    handleCompanySelect(company)
                                  }
                                  isSelected={selectedCompanies.some(
                                    (c) => c.id === company.id
                                  )}
                                />
                              ))}
                            </>
                          )}
                        </>
                      ) : location.state?.query?.length ? null : (
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <span className={styles.noResults}>
                            No results found in Traction
                          </span>
                          <span
                            onClick={() => handleCrunchBase(true)}
                            className={`${styles.noResultsUrl} mt-3`}
                          >
                            Search Crunchbase
                          </span>
                        </div>
                      )
                    ) : null}
                    {selectLayout === 1 ? (
                      companies?.length > 0 ? (
                        <NewCompaniesList
                          selectModeIsActive={selectModeIsActive}
                          companies={companies}
                          handleRelationShipChange={handleRelationShipChange}
                          handleCompanySelect={handleCompanySelect}
                          selectedCompanies={selectedCompanies}
                          downloadPdfIsActive={downloadPdfIsActive}
                        />
                      ) : location.state?.query?.length ? null : (
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <span className={styles.noResults}>
                            No results found in Traction
                          </span>
                          <span
                            onClick={() => handleCrunchBase(true)}
                            className={`${styles.noResultsUrl} mt-3`}
                          >
                            Search Crunchbase
                          </span>
                        </div>
                      )
                    ) : null}
                    {location.state?.query?.length && !searchResults?.length ? (
                      <div className="d-flex justify-content-center">
                        We didn't find any results for the key word&nbsp;
                        <b>{location.state?.query}</b>&nbsp; in Traction
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            )}
          </>
        )}
        {selectLayout !== 2 ? (
          <div
            className={`w-100 ${
              showPagination ? " d-flex" : "d-none"
            } justify-content-center mb-5 ${selectLayout === 1 ? "mt-4" : ""}`}
          >
            <Pagination
              {...pageSetting}
              onChange={(p) => handlePagingChange(p)}
            />
          </div>
        ) : null}
        {!loading && selectLayout === 2 && (
          <div className={styles.chartsContainer}>
            <ChartsWrapper totalCompaniesInDB={pageSetting?.total} />
          </div>
        )}
        {selectLayout === 2 &&
          (selectedCouncil?.name === "Donaldson" ||
            selectedCouncil?.name === "Ofi") &&
          chartsIntroIsActive && <ChartsIntro />}
      </div>
    </div>
  );
};

export default React.memo(RightWindowComponent);
